// Indicatore lock condiviso (2026-07-28) — "chi tiene aperta la pratica".
//
// Prima esisteva solo come markup duplicato inline in DdtList e RequestList,
// e mancava del tutto in BSC e Rinascente: un operatore non poteva sapere CHI
// avesse in carico una pratica ("con chi lamentarsi"). Qui e' un componente
// unico usato da tutte le liste, cosi' i verticali nuovi lo ereditano.
//
// Il lock ha TTL 5 minuti lato backend (rinnovato da un heartbeat finche' la
// pagina di dettaglio resta aperta): un lock piu' vecchio e' scaduto e non va
// mostrato, altrimenti la lista segnalerebbe come "occupate" pratiche libere.

const LOCK_TTL_MS = 5 * 60 * 1000;

export function isLockActive(lockedAt: string | null | undefined): boolean {
  if (!lockedAt) return false;
  return Date.now() - new Date(lockedAt).getTime() < LOCK_TTL_MS;
}

export function LockChip({
  lockedBy,
  lockedByName,
  lockedAt,
}: {
  lockedBy: string | null | undefined;
  lockedByName: string | null | undefined;
  lockedAt: string | null | undefined;
}) {
  if (!lockedBy || !isLockActive(lockedAt)) return null;
  const who = lockedByName || "un collega";
  return (
    <span title={`In lavorazione da ${who}`}
      style={{
        flexShrink: 0, display: "inline-flex", alignItems: "center", gap: 2,
        fontSize: "var(--font-size-xs)", fontWeight: 600,
        background: "var(--indaco-danger-light)", color: "var(--indaco-danger)",
        borderRadius: 10, padding: "1px 6px", whiteSpace: "nowrap", maxWidth: 140,
        overflow: "hidden", textOverflow: "ellipsis",
      }}>
      <span className="material-symbols-outlined" style={{ fontSize: 12 }}>lock</span>
      {who}
    </span>
  );
}
